module.exports = __webpack_public_path__ + "img/paice.e6e54c2a.jpg";